import { DocType } from '@/types/Documentation';

export enum AppRoutes {
  HOME = '/',
  DOCUMENTATION = '/documentation',
  DOCUMENTATION_ARTIFACT = '/documentation/[IntroArtifactUUID]?type=[type]',
  DOCUMENTATION_ARTIFACT_DETAIL = '/documentation/[IntroArtifactUUID]/[artifactUUID]?type=[type]',
  SIGNUP = '/signup',
  LOGIN = '/login',
  TEAM_INSIGHTS_SETUP = '/teaminsights-setup',
  PERFORMANCE_REVIEW = '/individual-insights',
  SETTINGS = '/settings',
}

export const getDocumentationArtifactRoute = (
  introArtifactUUID: string,
  type?: string
) => {
  return AppRoutes.DOCUMENTATION_ARTIFACT.replace(
    '[IntroArtifactUUID]',
    introArtifactUUID
  ).replace('[type]', type ?? DocType.TECH_DOCS);
};

export const getDocumentationArtifactDetailRoute = (
  introArtifactUUID: string,
  artifactUUID: string,
  type?: string
) => {
  return AppRoutes.DOCUMENTATION_ARTIFACT_DETAIL.replace(
    '[IntroArtifactUUID]',
    introArtifactUUID
  )
    .replace('[artifactUUID]', artifactUUID)
    .replace('[type]', type ?? DocType.TECH_DOCS);
};

const getPerformanceReviewRoute = (teamUUID: string) => {
  return (
    AppRoutes.PERFORMANCE_REVIEW + (teamUUID ? `?TeamUUID=${teamUUID}` : '')
  );
};

export const getRoute = (route: AppRoutes) => {
  return route;
};

export const getSignUpRoute = ({
  callbackURLAfterSignUp,
  signup,
  extensionName,
  loading,
  cli,
}: {
  callbackURLAfterSignUp?: string;
  signup?: string;
  extensionName?: string;
  loading?: string;
  cli?: string;
}) => {
  const params = new URLSearchParams();
  if (callbackURLAfterSignUp)
    params.set(
      'callbackURLAfterSignUp',
      callbackURLAfterSignUp.replace('//', '/')
    );
  if (signup) params.set('signup', signup);
  if (extensionName) params.set('extensionName', extensionName);
  if (loading) params.set('loading', loading);
  if (cli) params.set('cli', cli);
  const queryString = params.toString();
  return queryString ? `${AppRoutes.SIGNUP}?${queryString}` : AppRoutes.SIGNUP;
};

export const getLoginRoute = ({
  callbackURL,
  extensionName,
  loading,
  signup,
  cli,
}: {
  callbackURL?: string;
  extensionName?: string;
  loading?: string;
  signup?: string;
  cli?: string;
}) => {
  const params = new URLSearchParams();
  if (callbackURL)
    params.set('callbackURLAfterSignIn', callbackURL.replace('//', '/'));
  if (extensionName) params.set('extensionName', extensionName);
  if (loading) params.set('loading', loading);
  if (signup) params.set('signup', signup);
  if (cli) params.set('cli', cli);
  const queryString = params.toString();
  return queryString ? `${AppRoutes.LOGIN}?${queryString}` : AppRoutes.LOGIN;
};

export const mountUrlWithParams = (
  baseUrl: string,
  params: Record<string, string | boolean | undefined>
) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      searchParams.set(key, String(value));
    }
  });

  const queryString = searchParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};
